import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { ErrorBoundary } from "./App";
import { inject } from "@vercel/analytics";

// DSN is public by design (it ships to every visitor's browser), so it's safe to
// hard-code as the default. REACT_APP_SENTRY_DSN can still override it per-env.
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
  || "https://33b0217fbd03ee85c740cecf1fec4e10@o4511582697160704.ingest.de.sentry.io/4511582710595664";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_VERSION || "takehome-pro@1.0.0",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (event.exception) {
        const err = event.exception.values?.[0];
        const msg = err?.value || "";
        // ignore benign browser extension noise
        if (msg.includes("ResizeObserver loop") || msg.includes("Non-Error promise rejection")) {
          return null;
        }
      }
      return event;
    },
  });
}

inject();

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
